import React, { useMemo } from "react";
import { getSessionUser, isPlatformSuperAdmin, isCompanyAdmin } from "../../../utils/roleAccess";
import SuperAdminRoles from "./SuperAdminRoles";
import CompanyAdminRoles from "./CompanyAdminRoles";

function RolesPage() {
  const sessionUser = useMemo(() => getSessionUser(), []);
  if (isPlatformSuperAdmin(sessionUser?.role)) return <SuperAdminRoles />;
  if (isCompanyAdmin(sessionUser?.role)) return <CompanyAdminRoles />;
  return (
    <div className="m-5 bg-gx-border p-5 rounded-lg">
      <h3 className="text-xl font-bold text-center text-gx-ink-soft">
        Admin access required
      </h3>
    </div>
  );
}

export default RolesPage;
